import { useQuery } from 'react-query'

import { RestAPI } from '../RestAPI'

export function useGetSettings({ projectId }: { projectId?: string }) {
  return useQuery({
    queryFn: () =>
      RestAPI.get<{
        approvingDaysMax?: number
        signingDaysMax?: number
        remarkingDaysMax?: number
        createdAt: string
        createdByUserId?: string
        createdByUserName?: string
      }>(`/projects/${projectId}/deadlines-settings`).then(r => r.data),
    queryKey: ['project', projectId, 'deadlines-settings'],
    enabled: !!projectId,
  })
}
